import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators, AbstractControl } from '@angular/forms';
import { ApiAccessService } from '../../api-access.service';
import { Attachment } from '../../models/attachment.model';
import { Entity } from '../../models/entity.model';
import { Registration } from '../../models/registration.model';
import { RequirementDetail } from '../../models/requirement-detail.model';
import { Requirement } from '../../models/requirement.model';
import { SystemCode, SystemCodeModel } from '../../models/system-code.model';
import { navbarData } from '../sidenav/nav-data';
import { Router, Event, NavigationStart, NavigationEnd } from '@angular/router';
import { forEachChild } from 'typescript';

@Component({
  selector: 'app-business-process',
  templateUrl: './business-process.component.html',
  styleUrls: ['./business-process.component.css']
})
export class BusinessProcessComponent implements OnInit {
  @Output()
  close_model = new EventEmitter<string>();

  businessProcessForm: FormGroup;
  EntityDetails: FormGroup;
  entity: Registration;
  navData = navbarData;

  provinces: SystemCode[];
  countries: SystemCode[];
  months = ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  years: number[];
  options: {
    saving: boolean,
    duplicate: boolean,
    got_system_codes: boolean,
    uploading: boolean,
    complete: boolean,
    requirementClicked: RequirementDetail,
  }
  sites: number[];
  types: number[];

  constructor(private router: Router, private apiService: ApiAccessService) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        console.log("route changed");
        this.save('');
      }
    });
}

  ngOnInit(): void {

    this.businessProcessForm = new FormGroup({
      historyTonnage019: new FormControl(),
      historyTonnage020: new FormControl(),
      historyTonnage021: new FormControl(),
      historyTonnage022: new FormControl(),
      Loc1Tonnage: new FormControl(),
      Loc2Tonnage: new FormControl(),
      Loc3Tonnage: new FormControl(),
      Loc4Tonnage: new FormControl(),
      WEEEtonnage: new FormControl(),
      signContract: new FormControl(),
      statusCheck: new FormControl(),
      inspection: new FormControl(),
      WEEENotHandled: new FormControl(),
      WEEENotHandledType: new FormControl(),
      doReport: new FormControl(),
      returnTime: new FormControl(),
      weightMinimum: new FormControl(),
      perfomanceRoutine: new FormControl(),
      paymentCycle: new FormControl(0),
      collectionPreference: new FormControl(),
      paymentTimeFrame: new FormControl(0),
      complianceCertificate: new FormControl(0),
      specialisationCertificate: new FormControl(0),
      QMS: new FormControl(0),
      orderTicket: new FormControl(0),
      dataInflowRecorder: new FormControl(0),
      shipmentRecorder: new FormControl(0),
      dataOutflowRecorder: new FormControl(0),
      activityRecording: new FormControl(0),
      wasteManagementLicence: new FormControl(0),
      GDARDRegistration: new FormControl(0),
      GDARDRegistrationTransporter: new FormControl(0),
      secondhandGoodsLicence: new FormControl(0),
      letterofGoodStanding: new FormControl(0),
      ISO4001: new FormControl(0),
      dataSecurity: new FormControl(0),
      destructionCertificate: new FormControl(0),
      NEWMWA2127: new FormControl(0),
      municipalRegulations: new FormControl(0),
      transfrontierWEEELicence: new FormControl(0),
      focusMaterialTracking: new FormControl(0),
      ISO9001: new FormControl(0),
      ISO18001: new FormControl(0),

    });
    this.types = [];
    this.sites = [];
    this.add_site();
    this.add_types();
    this.reset_forms();
    
  }

  reset_forms() {
    if (sessionStorage.length > 0) {
      var obj = sessionStorage.getItem('businessprocessform');
      var ob = JSON.parse(obj);
      this.businessProcessForm.patchValue(ob);
    }
    this.entity = {
      attachments: [],
      company: {},
      companyEntity: {},
      contactPersons: [],
      entity: {},
      requirements: []
    };
    this.options = {
      saving: false,
      duplicate: false,
      got_system_codes: false,
      requirementClicked: null,
      uploading: false,
      complete: false
    };

  }

  add_types() {
   
    for (var num = 1; num < 11; num++) {
      this.businessProcessForm.addControl("transportCost" + num, new FormControl(""));
      this.businessProcessForm.addControl("recyclingCost" + num, new FormControl(""));
      this.businessProcessForm.addControl("positiveReturn" + num, new FormControl(""));
      this.businessProcessForm.addControl("consolidation" + num, new FormControl(""));
      this.businessProcessForm.addControl("destinationLocal" + num, new FormControl(""));
      this.businessProcessForm.addControl("overseasDestination" + num, new FormControl(""));
      this.types.push(num);
    }
  }

  add_site() {
    for (var num=1; num < 11; num++) {
      this.businessProcessForm.addControl("WEEEtonnage" + num, new FormControl(""));
      this.businessProcessForm.addControl("WEEEPercent" + num, new FormControl(""));
      this.businessProcessForm.addControl("disassemble" + num, new FormControl(""));
      this.businessProcessForm.addControl("consolidate" + num, new FormControl(""));
      this.businessProcessForm.addControl("localDestination" + num, new FormControl(""));
      this.sites.push(num);
    }
  }

  save(m) {

    if (this.businessProcessForm.value) {
      sessionStorage.setItem('businessprocessform', JSON.stringify(this.businessProcessForm.value));
      sessionStorage.setItem('businessProcess', "true");
      if (m) {
        window.alert("Your Information has been saved. Click on submit to complete your registration.")
      }
    }

  }



  pt1() {
    this.router.navigate(['service-portal/service-portal/site-info'])
  }

}
